import React, { createContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { encryptData } from '../helpers/utils';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [autenticado, setAutenticado] = useState(() => {
    return localStorage.getItem('auth') === 'true';
  });
  const [usuario, setUsuario] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [empresaId, setEmpresaId] = useState(() => {
    return localStorage.getItem('empresa_id') || null;
  });
  const [uidEmpresa, setUidEmpresa] = useState(() => {
    return localStorage.getItem('uid_empresa') || null;
  });

  useEffect(() => {
    if (autenticado) {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setUsuario(decoded.nombre);
          setEmpresa(decoded.empresa);
          const decodedUidEmpresa = decoded?.uid_empresa ? `${decoded.uid_empresa}` : null;
          setUidEmpresa(decodedUidEmpresa);
          if (decodedUidEmpresa) {
            localStorage.setItem('uid_empresa', decodedUidEmpresa);
          } else {
            localStorage.removeItem('uid_empresa');
          }
        } catch (error) {
          console.error('Error al decodificar el token', error);
          setUidEmpresa(null);
          localStorage.removeItem('uid_empresa');
        }
      }
    } else {
      setUsuario(null);
      setEmpresa(null);
      setEmpresaId(null);
      setUidEmpresa(null);
      localStorage.removeItem('auth');
      localStorage.removeItem('token');
      localStorage.removeItem('empresa_id');
      localStorage.removeItem('uid_empresa');
    }
  }, [autenticado]);

  const login = async (token, acceso, idEmpresa) => {
    setAutenticado(true);
    localStorage.setItem('auth', 'true');
    localStorage.setItem('token', token);
    
    // ✅ GUARDAR ID DE EMPRESA PARA CONTROL DE MENÚ
    if (idEmpresa) {
      localStorage.setItem('empresa_id', idEmpresa);
      setEmpresaId(idEmpresa);
    }
    
    try {
      const decoded = jwtDecode(token);
      setUsuario(decoded.nombre);
      setEmpresa(decoded.empresa);
      /*Guardado de uid empresa y */
      const uid_empresa = decoded?.uid_empresa ? `${decoded.uid_empresa}` : null;
      setUidEmpresa(uid_empresa);
      if (uid_empresa) {
        localStorage.setItem('uid_empresa', uid_empresa);
      } else {
        localStorage.removeItem('uid_empresa');
      }
      const token_consumo = JSON.stringify(acceso);
      if (uid_empresa) {
        guardarAcceso(token_consumo, uid_empresa);
      }
    } catch (error) {
      console.error('Error al decodificar el token en login', error);
      setUidEmpresa(null);
      localStorage.removeItem('uid_empresa');
    }
  };

  const logout = () => {
    setAutenticado(false);
    setUsuario(null);
    setEmpresa(null);
    setEmpresaId(null);
    setUidEmpresa(null);
    localStorage.removeItem('auth');
    localStorage.removeItem('token');
    localStorage.removeItem('empresa_id');
    localStorage.removeItem('uid_empresa');
  };

  const guardarAcceso = (acceso,clave)=>{
    try {
      let token_consumo = encryptData(acceso, clave);
      localStorage.setItem('token_consumo', token_consumo);
    } catch (error) {
      console.error('Error al codificar el acceso', error);
    }
  }

  return (
    <AuthContext.Provider value={{
      autenticado,
      setAutenticado,
      usuario,
      empresa,
      empresaId,
      uidEmpresa,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};